
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetStaticProps } from "next"
import Head from "next/head"

import getFilters from "@/graphql/requests/getFilters"
import SEO from "@/meta/SEO"
import { GoogleAnalytics } from "@/services/GA4/GoogleAnalytics"
import Default from "@/templates/Default"
import Creator from "@/ts/Creator"
import FansiKind from "@/ts/enums/global/FansiKind"
import ProductType from "@/ts/enums/product/ProductType"
import FilterGroup from "@/ts/interfaces/global/FilterGroup"
import ProductsView from "@/views/products"
import useStaticProducts from "@/views/products/functions/useStaticProducts"

const PRODUCT_TYPE = ProductType.FansiExperience

function ExperienceProductsPage({ staticFilters }: FansiExperiencePageProps) {
  const { filters } = useStaticProducts({
    staticFilters,
    productType: PRODUCT_TYPE,
  })

  if (!filters) return null

  return (
    <>
      <Head>
        <title>fansi Experience | fansi.pl</title>
        <SEO description="Przeżyj inspirujący czas z Twórcami, z którymi dzielisz te same wartości. Wykup dostęp i wejdź do gry – wyjątkowe doświadczenia gwarantowane!" />
      </Head>
      <GoogleAnalytics />
      <ProductsView
        filters={filters}
        productType={PRODUCT_TYPE}
        fansiKind={FansiKind.FansiExperience}
      />
    </>
  )
}

ExperienceProductsPage.Layout = Default

 const _getStaticProps: GetStaticProps = async () => {
  const staticFilters = await getFilters({ type: PRODUCT_TYPE })
  return { props: { staticFilters }, revalidate: 1 }
}

interface FansiExperiencePageProps {
  staticFilters: FilterGroup
  staticCreators: {
    creators: Creator[]
  }
}

export default ExperienceProductsPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/products/fansi-experience/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  